'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Hr = exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = exports.A = exports.Video = exports.Audio = exports.Canvas = exports.Img = exports.Aside = exports.Article = exports.Code = exports.Pre = exports.Button = exports.Option = exports.Select = exports.Textarea = exports.Input = exports.Form = exports.Footer = exports.Header = exports.Section = exports.Li = exports.Ul = exports.Label = exports.Span = exports.P = exports.Div = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _css = require('../css');

var _fsts = require('fsts');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _Div = function _Div(props) {
    return _react2.default.createElement(
        'div',
        props,
        props.children
    );
};
var Div = (0, _css.withMediaQuery)(_Div);

var _P = function _P(props) {
    return _react2.default.createElement(
        'p',
        props,
        props.children
    );
};
var P = (0, _css.withMediaQuery)(_P);

var _Span = function _Span(props) {
    return _react2.default.createElement(
        'span',
        props,
        props.children
    );
};
var Span = (0, _css.withMediaQuery)(_Span);

var _Label = function _Label(props) {
    return _react2.default.createElement(
        'label',
        props,
        props.children
    );
};
var Label = (0, _css.withMediaQuery)(_Label);

var _Ul = function _Ul(props) {
    return _react2.default.createElement(
        'ul',
        props,
        props.children
    );
};
var Ul = (0, _css.withMediaQuery)(_Ul);

var _Li = function _Li(props) {
    return _react2.default.createElement(
        'li',
        props,
        props.children
    );
};
var Li = (0, _css.withMediaQuery)(_Li);

var _Section = function _Section(props) {
    return _react2.default.createElement(
        'section',
        props,
        props.children
    );
};
var Section = (0, _css.withMediaQuery)(_Section);

var _Header = function _Header(props) {
    return _react2.default.createElement(
        'header',
        props,
        props.children
    );
};
var Header = (0, _css.withMediaQuery)(_Header);

var _Footer = function _Footer(props) {
    return _react2.default.createElement(
        'footer',
        props,
        props.children
    );
};
var Footer = (0, _css.withMediaQuery)(_Footer);

var _Form = function _Form(props) {
    return _react2.default.createElement(
        'form',
        props,
        props.children
    );
};
var Form = (0, _css.withMediaQuery)(_Form);

var _Input = function _Input(props) {
    return _react2.default.createElement(
        'input',
        props,
        props.children
    );
};
var Input = (0, _css.withMediaQuery)(_Input);

var _Textarea = function _Textarea(props) {
    return _react2.default.createElement(
        'textarea',
        props,
        props.children
    );
};
var Textarea = (0, _css.withMediaQuery)(_Textarea);

var _Select = function _Select(props) {
    return _react2.default.createElement(
        'select',
        props,
        props.children
    );
};
var Select = (0, _css.withMediaQuery)(_Select);

var _Option = function _Option(props) {
    return _react2.default.createElement(
        'option',
        props,
        props.children
    );
};
var Option = (0, _css.withMediaQuery)(_Option);

var _Button = function _Button(props) {
    return _react2.default.createElement(
        'button',
        props,
        props.children
    );
};
var Button = (0, _css.withMediaQuery)(_Button);

var _Pre = function _Pre(props) {
    return _react2.default.createElement(
        'pre',
        props,
        props.children
    );
};
var Pre = (0, _css.withMediaQuery)(_Pre);

var _Code = function _Code(props) {
    return _react2.default.createElement(
        'code',
        props,
        props.children
    );
};
var Code = (0, _css.withMediaQuery)(_Code);

var _Article = function _Article(props) {
    return _react2.default.createElement(
        'article',
        props,
        props.children
    );
};
var Article = (0, _css.withMediaQuery)(_Article);

var _Aside = function _Aside(props) {
    return _react2.default.createElement(
        'aside',
        props,
        props.children
    );
};
var Aside = (0, _css.withMediaQuery)(_Aside);

var _Img = function _Img(props) {
    return _react2.default.createElement(
        'img',
        props,
        props.children
    );
};
var Img = (0, _css.withMediaQuery)(_Img);

var _Canvas = function _Canvas(props) {
    return _react2.default.createElement(
        'canvas',
        props,
        props.children
    );
};
var Canvas = (0, _css.withMediaQuery)(_Canvas);

var _Audio = function _Audio(props) {
    return _react2.default.createElement(
        'audio',
        props,
        props.children
    );
};
var Audio = (0, _css.withMediaQuery)(_Audio);

var _Video = function _Video(props) {
    return _react2.default.createElement(
        'video',
        props,
        props.children
    );
};
var Video = (0, _css.withMediaQuery)(_Video);

var _A = function _A(props) {
    return _react2.default.createElement(
        'a',
        props,
        props.children
    );
};
var A = (0, _css.withMediaQuery)(_A);

var _H1 = function _H1(props) {
    return _react2.default.createElement(
        'h1',
        props,
        props.children
    );
};
var H1 = (0, _css.withMediaQuery)(_H1);

var _H2 = function _H2(props) {
    return _react2.default.createElement(
        'h2',
        props,
        props.children
    );
};
var H2 = (0, _css.withMediaQuery)(_H2);

var _H3 = function _H3(props) {
    return _react2.default.createElement(
        'h3',
        props,
        props.children
    );
};
var H3 = (0, _css.withMediaQuery)(_H3);

var _H4 = function _H4(props) {
    return _react2.default.createElement(
        'h4',
        props,
        props.children
    );
};
var H4 = (0, _css.withMediaQuery)(_H4);

var _H5 = function _H5(props) {
    return _react2.default.createElement(
        'h5',
        props,
        props.children
    );
};
var H5 = (0, _css.withMediaQuery)(_H5);

var _H6 = function _H6(props) {
    return _react2.default.createElement(
        'h6',
        props,
        props.children
    );
};
var H6 = (0, _css.withMediaQuery)(_H6);

var _Hr = function _Hr(props) {
    return _react2.default.createElement(
        'hr',
        props,
        props.children
    );
};
var Hr = (0, _css.withMediaQuery)(_Hr);

exports.Div = Div;
exports.P = P;
exports.Span = Span;
exports.Label = Label;
exports.Ul = Ul;
exports.Li = Li;
exports.Section = Section;
exports.Header = Header;
exports.Footer = Footer;
exports.Form = Form;
exports.Input = Input;
exports.Textarea = Textarea;
exports.Select = Select;
exports.Option = Option;
exports.Button = Button;
exports.Pre = Pre;
exports.Code = Code;
exports.Article = Article;
exports.Aside = Aside;
exports.Img = Img;
exports.Canvas = Canvas;
exports.Audio = Audio;
exports.Video = Video;
exports.A = A;
exports.H1 = H1;
exports.H2 = H2;
exports.H3 = H3;
exports.H4 = H4;
exports.H5 = H5;
exports.H6 = H6;
exports.Hr = Hr;


/*****************
 ** WEBPACK FOOTER
 ** ./~/fluid-react/dist/components/Dom.js
 ** module id = 759
 ** module chunks = 0
 **/